import React from 'react';
import Error from './Error';
import { Trans } from 'components';
import { Link } from 'react-router-dom';

const Error404 = () => (
  <Error
    title={<Trans>Wygląda na to, że zagubiłeś się w czasie i przestrzeni...</Trans>}
    subtitle={<Trans>Przykro nam, ale strona, którą próbujesz znależć nie istnieje.</Trans>}
  >
    <Link to="/" className="full-btn"><Trans>Powrót na stronę główną</Trans></Link>
  </Error>
);

export default Error404;


// WEBPACK FOOTER //
// ./src/components/ui/Error404.jsx